import type Paginated from 'app/core/paginable';
import { useGetApplication } from 'app/hooks';
import i18next from 'i18next';

import { baseUrl } from './http';
import { label } from './translation';
import { type ReportCell } from './types';

export const useReportCell = (id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<ReportCell>>({
    url: baseUrl,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [form] = data?.data || [];

  return { loading, data: form, error, response };
};

export const useReportCells = (reportVersionId: string, ignoreDefaultLang = false) => {
  return useGetApplication<Array<ReportCell>>({
    url: baseUrl + '/',
    params: { reportVersionId: reportVersionId },
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
};

export const useReportCellById = (reportVersionId: string, reportCellId: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<ReportCell>>({
    url: baseUrl + '/',
    params: { reportVersionId: reportVersionId, id: reportCellId }
  });

  const [reportCell] = data || [];

  return { loading, error, response, reportCell };
};

export const useReportCellTypes = () => {
  const types = ['numeric', 'currency', 'date', 'list', 'text'];
  return types.map((type) => ({
    id: type,
    name: label(i18next.t.bind(i18next), type)
  }));
};

export const useReportCellType = (type: string) => {
  const types = useReportCellTypes();
  return types.find((value) => value.id === type);
};
